// src/extenders/collapsible-content.js
var CollapsibleContent = class extends HTMLElement {
  constructor() {
    super();
    this.animationDelay = 200;
    this.toggle = this.querySelector("[aria-controls]");
    this.collapsible = this.querySelector("[aria-controlledby]");
    this.otherAccordions = this.parentElement.querySelectorAll("collapsible-content");
    this.oneOpenAtTime = this.hasAttribute("data-one-open");
    this.closeEventFunction = this.oneOpenAtTime ? this._closeAccordions.bind(this) : this._closeAccordion.bind(this);
  }
  connectedCallback() {
    this.toggle.addEventListener("click", this._toggleAccordion.bind(this));
    if (this.hasAttribute("data-hover")) {
      this.toggle.addEventListener("mouseenter", this._openAccordion.bind(this, false));
    }
  }
  _toggleAccordion() {
    if (this.toggle.getAttribute("aria-expanded") === "true") {
      this.oneOpenAtTime ? this._closeAccordions(true, true) : this._closeAccordion();
    } else {
      this._openAccordion(true);
    }
  }
  _openAccordion(clicked = false) {
    if (this.oneOpenAtTime) {
      this._closeAccordions(false);
    }
    this.collapsible.setAttribute("aria-hidden", "false");
    this.toggle.setAttribute("aria-expanded", "true");
    const delayedAuto = this.collapsible.querySelector("[data-delayed-auto]");
    if (delayedAuto) {
      setTimeout(() => {
        delayedAuto.classList.remove("overflow-hidden");
        delayedAuto.classList.add("overflow-auto");
      }, this.animationDelay);
    }
    if (!clicked) {
      this.addEventListener("mouseleave", this.closeEventFunction);
    }
  }
  _closeAccordion() {
    this.collapsible.setAttribute("aria-hidden", "true");
    this.toggle.setAttribute("aria-expanded", "false");
    const delayedAuto = this.collapsible.querySelector("[data-delayed-auto]");
    if (delayedAuto) {
      delayedAuto.classList.remove("overflow-auto");
      delayedAuto.classList.add("overflow-hidden");
    }
  }
  _closeAccordions(closeSelf = true, clicked = false) {
    this.toggle.focus();
    if (closeSelf) {
      this.otherAccordions.forEach((accordion) => {
        accordion.collapsible.setAttribute("aria-hidden", "true");
        accordion.toggle.setAttribute("aria-expanded", "false");
        const delayedAuto = accordion.collapsible.querySelector("[data-delayed-auto]");
        if (delayedAuto) {
          delayedAuto.classList.remove("overflow-auto");
          delayedAuto.classList.add("overflow-hidden");
        }
      });
    } else {
      this.otherAccordions.forEach((accordion) => {
        if (accordion !== this) {
          accordion.collapsible.setAttribute("aria-hidden", "true");
          accordion.toggle.setAttribute("aria-expanded", "false");
          const delayedAuto = accordion.collapsible.querySelector("[data-delayed-auto]");
          if (delayedAuto) {
            delayedAuto.classList.remove("overflow-auto");
            delayedAuto.classList.add("overflow-hidden");
          }
        }
      });
    }
    if (!clicked) {
      this.removeEventListener("mouseleave", this.closeEventFunction);
    }
  }
};
if (!window.customElements.get("collapsible-content")) {
  window.customElements.define("collapsible-content", CollapsibleContent);
}
